export default __webpack_public_path__ + "static/media/contacthome.5026c09a.jpg";